import angular from 'angular';

export default angular.module('app.services.progressBar', [])
  .service('setProgressBar', function ($timeout, $q) {
    return function (model, filesAmount, loadedFilesAmount) {
      if (!model.progressBarPercent) {
        model.progressBarPercent = 0;
      }
      model.showProgressBar = true;
      model.progressBarPercent = loadedFilesAmount * 100 / filesAmount;
      if (loadedFilesAmount == filesAmount) {
        model.progressBarPercent = 100;
        $timeout(() => {
          model.progressBarPercent = 0;
        }, 2000);
        return $timeout(() => {
          model.showProgressBar = false;
        }, 1000);
      }
    }
  })



/** WEBPACK FOOTER **
 ** ./src/services/progressBarSetter.js
 **/